import React from 'react';

import { Article, Attachment, AttachmentCategory, Case, VideoCase } from '../../../api/caseApiTypes';
import { CaseArticles } from '../CaseArticles';
import { CaseDetailEnrichmentSubForm } from './CaseDetailEnrichmentSubForm';
import { CaseFormSection } from './CaseFormSection';
import { Right } from '../../../api/userApi';
import { CaseVideoRequestForm } from './CaseVideoRequestForm';
import {Button} from "@mui/material";
import {addCaseVideoRequest, removeCaseVideoRequest } from '../caseDetailSlice';
import { useAppDispatch } from '../../../hooks/useAppRedux';
import { CaseVideoRequestAttachments } from '../CaseVideoRequestAttachments';

type TCase = VideoCase;

interface Props {
  caze: TCase;
  isNewCase?: boolean;
  readonly?: boolean;
  onChange: (partial: Partial<Case>) => void;
  onUpsertArticle?: (article: Article) => void;
  onUpsertManyArticles?: (articles: Article[]) => void;
  onDeleteArticle?: (article: Article) => void;
  onDeleteAttachment: (attachment: Attachment) => void;
}

export const VideoCaseDetailFormFields: React.FC<Props> = ({
  caze,
  isNewCase,
  readonly,
  onChange,
  onUpsertArticle,
  onUpsertManyArticles,
  onDeleteArticle,
  onDeleteAttachment,
}) => {
  const dispatch = useAppDispatch();

  const removeVideoRequest = (item: Case, videoRequestId: string) => {
    if (window.confirm(`Är du säker på att du vill ta bort den rörliga beställningssektionen?`)) {
      dispatch(removeCaseVideoRequest({item, videoRequestId}));
    }
  };

  const addVideoRequest = (item: Case) => {
    dispatch(addCaseVideoRequest({ item }));
  };

  return (
    <>
      <CaseFormSection caseId={caze.id} title="Artiklar" description="Dessa artiklar ska vara med i filmerna">
        <CaseArticles
          articles={caze.articles}
          onUpsert={onUpsertArticle}
          onAddMany={onUpsertManyArticles}
          onDelete={onDeleteArticle}
          isNewCase={isNewCase}
          readonly={readonly}
          renderExtraInfo
          enableDrag
          showArticleTypeTitle
          groupByArticleType
        />
      </CaseFormSection>

      <CaseFormSection caseId={caze.id}
                       title="Bildbeställning Rörligt"
                       description="Här beskriver du dina önskemål om rörligt">
        {caze.videoRequests?.map((videoRequest, index) => (
          <CaseVideoRequestForm caze={caze}
                                key={`${caze.id}-videoRequest-${index}`}
                                request={videoRequest}
                                index={index}
          >
            <CaseVideoRequestAttachments
              caze={caze}
              videoRequest={videoRequest}
              onDelete={onDeleteAttachment}
              category={AttachmentCategory.SupplementaryInformation}
              right={Right.WriteCase}
              isNewCase={isNewCase}
            />
            <Button onClick={() => removeVideoRequest(caze, videoRequest.id)} variant="outlined">
              Ta bort Rörlig Beställning
            </Button>
            <hr style={{borderColor: 'gray', width: '100%'}}/>
          </CaseVideoRequestForm>
        ))}
        {caze.videoRequests && caze.videoRequests.length < 3 && (
          <Button variant="contained" onClick={() => addVideoRequest(caze)} size="medium">
            +Rörlig Beställning
          </Button>
        )}
      </CaseFormSection>
      <CaseDetailEnrichmentSubForm caze={caze} onChange={onChange} />
    </>
  );
};
